import { ICompanyDetails } from 'modules/_common/models';
import API from 'services/api';

export const getCompanyDetails = (): Promise<ICompanyDetails> =>
  API.get('/api/profile/company')?.then(res => res?.data);
